/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'SpecPhoneProtect',
    path: '/spec/phone-protect',
    component: () =>
      import(
        /* webpackChunkName: "SpecPhoneProtect" */ '@/views/spec/phone-protect'
      ),
    meta: { title: ' ' },
  },
  {
    name: 'SpecPriceRule',
    path: '/spec/price-rule',
    component: () =>
      import(/* webpackChunkName: "SpecPriceRule" */ '@/views/spec/price-rule'),
    meta: { title: '小拉出行计费规则' },
  },
  {
    name: 'SpecCostDesc',
    path: '/spec/cost-desc',
    component: () =>
      import(/* webpackChunkName: "SpecCostDesc" */ '@/views/spec/cost-desc'),
    meta: { title: '' },
  },
  {
    name: 'SpecTrackShare',
    path: '/spec/track-share',
    component: () =>
      import(
        /* webpackChunkName: "SpecTrackShare" */ '@/views/spec/track-share'
      ),
    meta: { title: '行程分享' },
  },
  {
    name: 'RideRule',
    path: '/spec/ride-rule',
    component: () =>
      import(/* webpackChunkName: "RideRule" */ '@/views/spec/ride-rule'),
    meta: { title: '用车规则' },
  },
  {
    name: 'LawRule',
    path: '/spec/law-rule',
    component: () =>
      import(/* webpackChunkName: "RideRule" */ '@/views/spec/law-rule'),
    meta: { title: '法律条款与平台规则' },
  },
  {
    name: 'SpecEmpty',
    path: '/spec/empty',
    component: () =>
      import(/* webpackChunkName: "SpecEmpty" */ '@/views/spec/empty'),
    meta: { title: '优惠活动' },
  },
];
